import SuccessIcon from "../../assets/thank-you.svg"
import "./success-toaster.css"

const CustomSuccessToaster = ({
    successMessage,
}) => {
    return (
        <div className="custom-success-wrapper">
            <img src={SuccessIcon} className="success-icon" />
            <span>{successMessage}</span>
        </div>
    );
};

export default CustomSuccessToaster;
